<template>
  <list-page icone="mdi-binoculars" titulo="Captação" @novo="Novo()" @atualizar="Listar()" :temBuscaRapida="true" :buscaRapida.sync="search">
    <template v-slot:botoes>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon small @click="tableToExcel('tabela')" v-on="on" style="font-size: 22px; color: var(--v-primary-base)">mdi-file-excel</v-icon>
        </template>
        <span>Exportar</span>
      </v-tooltip>
      <div>
        <info/>
      </div>
    </template>
    <template v-slot:corpo>
      <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">        
        
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.anexo`]="{ item }">
          <a @click="Download(item)">{{ item.anexo }}</a>
        </template>

        <template v-slot:[`item.probabilidade`]="{ item }">
          {{item.probabilidadeStr}}
        </template>

        <template v-slot:[`item.fonte`]="{ item }">
          {{item.fonteStr}}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          {{item.statusStr}}
        </template>

        <template v-slot:[`item.leiIncentivo`]="{ item }">
          {{item.leiIncentivoStr}}
        </template>
        
      </v-data-table>     

      <v-overlay :value="primeiraCarga">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <cadastro-oportunidade v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>

    </template>
  </list-page>
</template>

<script>
import OportunidadeService from '@/core/services/doacao/OportunidadeService';
import Oportunidade from '@/core/domain/doacao/Oportunidade';
import ListPage from "@/components/shared/ListPage";
import { TableToExcel } from "@/assets/js/custom"

export default {
    extends: ListPage,
    data: () => ({
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Valor', value: 'valorTotal', type:'number' },
        { text: 'Prob. %', value: 'probabilidade', type:'number' },
        { text: 'Fonte', value: 'fonte', type:'number' },
        { text: 'Status', value: 'status', type:'number' },
        { text: 'Lei Incentivo', value: 'leiIncentivo', type:'number' },
        { text: 'Anexo', value: 'anexo' }
      ],
      primeiraCarga: true,
      tableToExcel: TableToExcel
    }),
    watch:{
      lista: function(){
        if(this.primeiraCarga)
          this.primeiraCarga = false;
      }
    },
    created() {
      this.service = new OportunidadeService();
    },
    methods: {
      Novo(){
        this.NovoCadastro(new Oportunidade());
      },
      Editar(item){
        this.service.ObterPorId(item.id, "Doador.Contatos")
          .then(
            res =>{
              this.EditarCadastro(new Oportunidade(res.data));
            },
            err => this.$swal('Aviso', err.response.data, 'error')
          )
      },
      Download(item){
        this.service.DownloadDocumento(item.id, item.anexo);
      }
    },
    mounted() {
      this.Listar()
    }
}
</script>
<style scoped>

</style>
